// extracted by mini-css-extract-plugin
export default {"special-div":"OurSpecial_special-div__kenId","special-title":"OurSpecial_special-title__tVnVi"};